import React, { useState } from 'react';
import { Link, router } from '@inertiajs/react';
import Layout from '../../../components/Layout.jsx';
import ConfirmDialog from '../../../components/ConfirmDialog.jsx';

export default function SuperadminSalesRepsIndex({ sales_reps = [], filters = {} }) {
  const [query, setQuery] = useState(filters.q || '');
  const [pendingDelete, setPendingDelete] = useState(null);
  const [busy, setBusy] = useState(false);

  const handleSearch = (e) => {
    e.preventDefault();
    router.get('/superadmin/sales_reps', { q: query }, { preserveState: true, preserveScroll: true });
  };

  const confirmDelete = () => {
    if (!pendingDelete) return;
    setBusy(true);
    router.delete(`/superadmin/sales_reps/${pendingDelete.id}`, {
      onFinish: () => { setBusy(false); setPendingDelete(null); },
    });
  };

  return (
    <Layout>
      <div className="max-w-5xl mx-auto p-6 sm:p-8 space-y-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
          <div>
            <h1 className="text-3xl font-bold tracking-tight text-gray-900">Sales reps</h1>
            <p className="mt-1 text-sm text-gray-500">
              Reps sign in with an emailed link and can only create and view their own deals.
            </p>
          </div>
          <Link href="/superadmin/sales_reps/new"
                className="shrink-0 inline-flex items-center rounded-lg bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-indigo-700 transition">
            Add sales rep
          </Link>
        </div>

        <form onSubmit={handleSearch} className="flex gap-2">
          <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search name or email"
                 className="flex-1 rounded-lg border border-gray-200 px-3.5 py-2.5 text-sm" />
          <button type="submit" className="rounded-lg border border-gray-200 px-4 py-2.5 text-sm font-semibold text-gray-700 hover:bg-gray-50 cursor-pointer">
            Search
          </button>
        </form>

        {sales_reps.length === 0 ? (
          <div className="rounded-2xl border border-dashed border-gray-200 bg-white p-10 text-center">
            <p className="text-sm text-gray-500">No sales reps yet.</p>
          </div>
        ) : (
          <ul className="space-y-3">
            {sales_reps.map((rep) => (
              <li key={rep.id} className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm flex items-center justify-between gap-4 flex-wrap">
                <div className="min-w-0">
                  <Link href={`/superadmin/sales_reps/${rep.id}`} className="text-base font-semibold text-gray-900 hover:text-indigo-700">
                    {rep.name}
                  </Link>
                  <p className="mt-0.5 text-xs text-gray-500">
                    {rep.email} · {rep.deals_count} deal{rep.deals_count === 1 ? '' : 's'} · added {rep.created_at}
                  </p>
                </div>
                <div className="flex items-center gap-3 shrink-0 text-sm">
                  <Link href={`/superadmin/sales_reps/${rep.id}/edit`} className="font-semibold text-gray-600 hover:text-gray-900">
                    Edit
                  </Link>
                  <button type="button" onClick={() => setPendingDelete(rep)}
                          className="font-semibold text-red-700 hover:text-red-800 cursor-pointer">
                    Remove
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>

      <ConfirmDialog
        open={pendingDelete !== null}
        title={`Remove ${pendingDelete?.name}?`}
        body="They lose access immediately. Deals they created are kept, but stop showing who authored them."
        confirmLabel="Remove rep"
        busy={busy}
        onConfirm={confirmDelete}
        onCancel={() => setPendingDelete(null)}
      />
    </Layout>
  );
}
